export default [
    {
        id: 'concept-testing',
        meta: {
            title: 'Concept Testing Services for CPG Products | Peekage',
            description: 'Peekage offers concept testing services for CPG brands to help you determine which product ideas will be most effective.',
        },
        hero: {
            subtitle: 'Concept Testing Services',
            title: 'Validate Ideas Before You Lunch',
            description: '',
            image: 'caseStudies/usecases/conceptTesting/concept-testing-hero.png',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
            moreContext: "Make confident decisions before you invest time, budget, or resources.Our concept testing services help you validate ideas with real customer feedback, so you move forward with clarity, not assumptions.",
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'Concept Testing Services That Turn Ideas Into Winners',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'Validate your strongest product ideas through our top concept testing services. Discover which product or service concepts offer real market potential, and which may drain valuable R&D resources. Evaluate every element of your concept, from features and branding to messaging, to ensure a successful launch.',
                bullets: [
                    'Measure overall concept performance',
                    'Uncover key strengths and potential gaps',
                    'Ensure alignment with your brand strategy',
                ],
                image: 'caseStudies/usecases/conceptTesting/single-feature.png',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'Concepts You Can Test with Peekage',
                description: '',
                iconWidth: 28,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/ProductConcepts1.png',
                        title: 'Product Concepts',
                        caption: 'We test how clear, useful, and appealing your product idea feels to the right audience.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/ProductConcepts2.png',
                        title: 'Pricing Concepts',
                        caption: 'We test how different price points or pricing models affect perceived value and purchase intent.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/ProductConcepts3.png',
                        title: 'Package Concepts',
                        caption: 'We test which presentation of the product people prefer and what they expect to be included.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/ProductConcepts4.png',
                        title: 'Messaging & Positioning Concepts',
                        caption: 'We test which messages communicate your value best and help your concept stand out.',
                    },
                ],
            },
            {
                title: 'How Quality Concept Testing Services Help You Do Better',
                description: 'Consumer Insight for',
                iconWidth: 28,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts1.png',
                        title: 'Identifies Good & Bad Ideas',
                        caption: 'Know which ideas deserve a green light and which should remain ideas.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts2.png',
                        title: 'Saves Time & Money',
                        caption: 'Spend less fixing mistakes and more building what works.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts3.png',
                        title: 'Gives a Competitive Advantage',
                        caption: 'Make moves with insight, not instinct, and stay one step ahead.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts4.png',
                        title: 'Reveals What Drives Interest',
                        caption: 'See exactly what grabs attention and what gets ignored.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts5.png',
                        title: 'Helps Develop Ideas that Sell',
                        caption: 'Turn promising concepts into offers people actually want to buy.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/conceptTesting/values/qcts6.png',
                        title: 'Gives Validation of Your Idea',
                        caption: 'Get proof before you commit, so every investment pays off.',
                    },
                ],
            },
        ],
        features: {
            title: 'Advanced Concept Testing Methods We Use',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Monadic Concept Testing',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Test one concept in isolation so people react without being influenced by other options. Ideal for clear first impressions on value, clarity, and appeal.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature1.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Comparative Concept Testing',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Test multiple concepts with the same audience to see which one performs best and why. Great when you need a confident winner between options.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature2.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'MaxDiff Analysis',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Identify what matters most by having people pick the most and least influential features. This produces clean priorities you can build around.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature3.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 4,
                    title: 'Prototype Testing',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Validate an early version of your product or experience to catch confusion, friction, and missing details before development goes further.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature4.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 5,
                    title: 'Idea Screening',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Quickly score and rank a large list of ideas to create a shortlist worth improving and testing deeper.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature5.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 6,
                    title: 'Key Driver Analysis',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Identify the key factors such as product quality, packaging, or price have the most significant influence on consumer purchasing decisions.',
                    image: 'caseStudies/usecases/conceptTesting/features/feature6.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations. With a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines. This valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'community/community.png',
                    imageAlt: 'Our community',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ]
        },
        howItWorks: {
            title: 'How Concept Testing Works with Peekage',
            items: [
                {
                    id: 1,
                    image: 'insights/howItWorks/1.png',
                    title: 'Design Study',
                    description: 'Start by asking a business question and let Peekage AI automatically generate an optimized study for you, or craft your study from scratch.',
                },
                {
                    id: 2,
                    image: 'insights/howItWorks/2.png',
                    title: 'Select Recruitment Criteria',
                    description: 'Build your segments using over 200 consumer attributes or utilize our instant screening feature to incorporate additional screening criteria as needed.',
                },
                {
                    id: 3,
                    image: 'insights/howItWorks/3.png',
                    title: 'Build Questionnaire',
                    description: 'Review your pre-filled questionnaire and insert expert-designed questions from our question bank or create your own from scratch using over 20 different question types.',
                },
                {
                    id: 4,
                    image: 'insights/howItWorks/4.png',
                    title: 'Implement Logic',
                    description: 'Implement logic and pipelining into your questionnaire to craft various user journeys.',
                },
                {
                    id: 5,
                    image: 'insights/howItWorks/5.png',
                    title: 'Launch Campaign',
                    description: 'Launch your campaign and monitor live analytics as data flows in.',
                },
                {
                    id: 6,
                    image: 'insights/howItWorks/6.png',
                    title: 'Review & Analyze Data',
                    description: 'Utilize advanced reporting & data visualization to get a holistic view of incoming data. ',
                },
                {
                    id: 7,
                    image: 'insights/howItWorks/7.png',
                    title: 'Utilize Actionable Insight',
                    description: 'Leverage Peekage recommendations and slice and dice data based on user attributes or responses.',
                },
                {
                    id: 8,
                    image: 'insights/howItWorks/8.png',
                    title: 'Export Data',
                    description: 'Easily export and incorporate data into your reports and presentations.',
                },
            ]
        },
        customerStories: {
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage’s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            title: 'Related Resources',
            items: [
            {
                image: 'caseStudies/usecases/conceptTesting/resources/resource1.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/concept-testing-tools">Concept Testing Tools</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Discover top concept testing tools that help boost sales of CPG brands.</span></div>',
                uri: '/concept-testing/concept-testing-tools',
                alt: 'Concept Testing Tools',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/resource2.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/concept-testing-examples">Concept Testing Examples</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Explore real-world concept testing examples every brand should know.</span></div>',
                uri: '/concept-testing/concept-testing-examples',
                alt: 'Concept Testing Examples',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/resource3.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/concept-testing-questions">Concept Testing Questions</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Leverage proven concept testing questions to get the best out of it.</span></div>',
                uri: '/concept-testing/concept-testing-questions',
                alt: 'Concept Testing Questions',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/resource4.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/what-is-concept-testing">What is Concept Testing for CPG Products?</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Learn how to conduct concept testing for CPG products, main methods & tools.</span></div>',
                uri: '/concept-testing/what-is-concept-testing',
                alt: 'What is Concept Testing for CPG Products',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/concept-testing-vs-usability-testing.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/concept-testing-vs-usability-testing">Concept Testing vs Usability Testing</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Discover the similarities and differences between concept & usability testing.</span></div>',
                uri: '/concept-testing/concept-testing-vs-usability-testing',
                alt: 'Concept Testing vs Usability Testing',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/monadic-testing.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/monadic-testing">Monadic Testing</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Learn how monadic testing helps validate product concepts with unbiased feedback.</span></div>',
                uri: '/concept-testing/monadic-testing',
                alt: 'Monadic Testing',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/prototype-testing.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/prototype-testing">Prototype Testing</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Discover prototype testing methods to evaluate and validate your CPG product concept.</span></div>',
                uri: '/concept-testing/prototype-testing',
                alt: 'Prototype Testing',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/key-driver-analysis.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/key-driver-analysis">Key Driver Analysis</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Identify what truly drives purchase decisions and satisfaction with key driver analysis.</span></div>',
                uri: '/concept-testing/key-driver-analysis',
                alt: 'Key Driver Analysis',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/idea-screening.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/idea-screening">Idea Screening</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Learn how idea screening helps you choose winning concepts for your product.</span></div>',
                uri: '/concept-testing/idea-screening',
                alt: 'Idea Screening',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/comparative-testing.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/comparative-testing">Comparative Testing</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Run comparative concept testing to see which option consumers prefer.</span></div>',
                uri: '/concept-testing/comparative-testing',
                alt: 'Comparative Testing',
            },
            {
                image: 'caseStudies/usecases/conceptTesting/resources/maxdiff-analysis.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/concept-testing/maxdiff-analysis">MaxDiff Analysis</a></h3><span class="font-manrope leading-4 font-normal text-black text-[14px]">Use MaxDiff analysis to uncover what consumers truly value most.</span></div>',
                uri: '/concept-testing/maxdiff-analysis',
                alt: 'MaxDiff Analysis',
            },
            ],
        },
    },
    {
        id: 'usage-and-attitude-testing-services',
        meta: {
            title: 'Usage and Attitudes Testing Services for Smarter Brand Strategy | Peekage',
            description: 'Peekage\'s usage and attitude testing services reveal how consumers think, buy, and use products, so you can make smarter, data-backed decisions.',
        },
        hero: {
            subtitle: 'Usage and Attitudes Testing Services',
            title: 'Usage and Attitudes Testing Services',
            description: '',
            moreContext: 'Our professional usage and attitudes testing services provide clear insights into consumer behavior, preferences, and purchase drivers. By analyzing these patterns, you can identify market gaps, uncover growth opportunities, and refine your brand and product strategies to meet evolving consumer needs and stay ahead of the competition.',
            image: 'caseStudies/usecases/usageAndAttitudeTesting/hero.png',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'How Does Usage and Attitudes Testing Work?',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'A usage and attitudes (U&A) study is a proven market research method that examines how consumers interact with your product, service, or brand, and what drives their choices. Our professional U&A testing helps CPG brands identify market gaps, anticipate emerging trends, and refine go-to-market strategies. By analyzing consumer habits, perceptions, and behavior, the usage and attitudes (U&A) test provides valuable insights to optimize your product offerings, strengthen competitive positioning, and improve your customer targeting to drive growth and engagement.',
                image: 'caseStudies/usecases/usageAndAttitudeTesting/how-it-works.png',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'Why Choose Peekage\'s Usage and Attitudes Testing Services?',
                description: '',
                iconWidth: 40,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/pencil-square.png',
                        title: 'Expert-Designed U&A Studies',
                        caption: 'Use our expert-built study templates, complete with researcher-optimized questions and logic, to save time creating your survey. They are fully customizable to meet your specific needs.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/align-text-top.png',
                        title: 'Real-time Consumer Reports',
                        caption: 'Peekage Insight engine instantly analyzes live collected data, turning it into clear, easy-to-read charts and reports, giving you access to first-party consumer insights and U&A analysis in a matter of hours instead of weeks.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/search-category.png',
                        title: 'Actionable Insights on the Board',
                        caption: 'Peekage Insight AI agent works like a team of expert researchers and data scientists, going beyond standard reports to uncover deep insights. It then delivers actionable recommendations that help you make smarter and faster decisions.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/webcam.png',
                        title: 'Targeted Consumer Recruitment',
                        caption: 'Leverage 200+ consumer attributes to precisely target your ideal consumer niche and maximize the efficiency of your usage & attitudes research study, improving segmentation and insight quality.',
                    },
                ],
            },
            {
                title: 'How Our Usage & Attitude Testing Services Help Your Brand',
                description: '',
                iconWidth: 40,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/graph-arrow-increase.png',
                        title: 'Identify Growth Opportunities You Can\'t See From Inside',
                        caption: 'Our usage and attitude testing service aims to understand a market and identify growth opportunities by answering important questions.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/toilet-man.png',
                        title: 'Build Smarter Consumer Segmentation',
                        caption: 'Usage and attitude research enhances targeting and marketing with data-based segmentation, going beyond basic demographics to group consumers.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/check-square.svg',
                        title: 'Inform Product Development With Real Unmet Needs',
                        caption: 'Our usage and attitude service can reveal underserved consumer occasions and needs that no brand is currently serving effectively and consistently.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/target.png',
                        title: 'Strengthen Your Marketing Relevance',
                        caption: 'Peekage\'s usage and attitude testing services give your creative and marketing teams the specific insights needed to build campaigns that speak directly to what your audience values.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/stairs-1.png',
                        title: 'Sharpen Your Competitive Strategy',
                        caption: 'A well-run usage and attitude service offers a broader lens into the category - revealing where competitors are failing to consistently meet expectations.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/usageAndAttitudeTesting/graph.png',
                        title: 'Track Market Shifts Before They Surprise You',
                        caption: 'Consumer behavior doesn\'t stay still. If your brand notices a shift in how consumers feel about your category, a usage and attitude research helps you understand those changes.',
                    },
                ],
            },
        ],
        features: {
            title: 'The Advantages of Peekage\'s Usage & Attitude Testing Services',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Determine Key Purchase Drivers',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Uncover the underlying motivations behind consumer choices with a U&A study market research approach. By analyzing subconscious attitudes and purchase behaviors, you can identify what truly drives decisions and brand loyalty. These insights help refine marketing strategies, enhance messaging, and optimize product positioning to better align with consumer needs.',
                    image: 'caseStudies/usecases/usageAndAttitudeTesting/advantages-purchase-drivers.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Identify Market Gaps and Shape Product Strategy',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'A usage and attitude testing reveals unmet consumer needs and emerging trends, helping you refine product offerings and optimize brand strategies. By analyzing consumer habits and brand perceptions, you can strengthen your competitive positioning and drive market success.',
                    image: 'caseStudies/usecases/usageAndAttitudeTesting/advantages-market-gaps.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'Understand the Competitive Landscape',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Discover how your brand or product stacks up against competitors and identify key attributes that set you apart. Leverage these insights from usage and attitudes research services to refine your positioning strategy, enhance your value proposition, and maintain a competitive edge in the market.',
                    image: 'caseStudies/usecases/usageAndAttitudeTesting/advantages-competitive-landscape.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations. With a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines. This valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'community/community.png',
                    imageAlt: 'Our community',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ],
        },
        customerStories: {
            stories: [
                {
                    image: 'caseStudies/picture/bellwether-farms.png',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;"><span style="color: #11676A;">Winning Key Retailers </span>Through Consumer Persona Insights</span>',
                    uri: '/',
                    alt: 'Wise Snacks consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/tribe9.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">How Consumer Testing Helped YumButter Optimize Packaging for <span style="color: #FF8524;">Bigger Impact</span> and Better ROI</span>',
                    uri: '/',
                    alt: 'Tribe9Foods consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/wise-snacks.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks Cuts Research Costs <span style="color: #F78834;">by 70% </span>and Speeds Up IHUT 4X</span>',
                    uri: '/',
                    alt: 'Bellwether customer insights case study',
                },
            ],
        },
        howItWorks: {
            title: 'Peekage’s Process for Attitudes and Usage Study',
            items: [
                {
                    id: 1,
                    title: 'Target Ideal Consumers',
                    description: 'Use Peekage\'s first-party network and targeting tools to recruit participants for your usage and attitudes services, based on demographics, behaviors, and shopping habits.',
                    image: 'insights/howItWorks/1.png',
                },
                {
                    id: 2,
                    title: 'Launch an Optimized Study',
                    description: 'Use expert-designed templates and customize them to your needs to capture detailed consumer usage patterns and attitudes.',
                    image: 'insights/howItWorks/2.png',
                },
                {
                    id: 3,
                    title: 'Collect and Analyze Real-Time Data',
                    description: 'Gain instant access to live consumer responses and easy-to-understand reports and visualizations for deeper insights.',
                    image: 'insights/howItWorks/3.png',
                },
                {
                    id: 4,
                    title: 'Review Reports and Insights',
                    description: 'Let Peekage AI uncover key trends and market gaps, delivering actionable recommendations for your product and brand strategy through its usage and attitudes services.',
                    image: 'insights/howItWorks/4.png',
                },
            ],
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage\'s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            title: 'Related Resource',
            items: [
                {
                    image: 'caseStudies/usecases/usageAndAttitudeTesting/usage-and-attitude-article-link-card-image.png',
                    description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="https://peekage.com/blog/usage-and-attitude">What Is Usage and Attitude and How Can It Help CPG Brands</a></h3></div>',
                    uri: 'https://peekage.com/blog/usage-and-attitude',
                    alt: 'What Is Usage and Attitude and How Can It Help CPG Brands',
                },
            ],
        },
        faqItems: [
            {
                title: 'How customizable are your usage and attitudes testing templates?',
                content: 'They\'re quite flexible. You get ready-made templates to start quickly, but you can easily tweak them, change questions, adjust the flow, or tailor everything to fit your specific research needs.',
            },
            {
                title: 'Do you provide pre-built questions for the usage and attitudes survey, or can we create our own?',
                content: 'Both. You can either use pre-built, research-backed questions or create your own from scratch. Most teams mix the two depending on what they want to learn.',
            },
            {
                title: 'How do you recruit the panel for the usage and attitudes research?',
                content: 'We recruit from a large, pre-built consumer panel with millions of users. You can filter and target participants based on things like demographics, behavior, interests, and buying habits so you reach the exact audience you need.',
            },
            {
                title: 'Do you offer support in the process of designing and launching the usage and attitudes study?',
                content: 'Yes. You\'re not left on your own. You can use ready-made templates or AI guidance, and the platform helps you set up the survey, choose your audience, and launch everything smoothly.',
            },
            {
                title: 'How long does the usage and attitudes survey run?',
                content: 'Usually just a few days. Since responses come in fast and in real time, you don\'t have to wait weeks like in traditional research.',
            },
            {
                title: 'What insights can I gain from your U&A study?',
                content: {
                    intro: 'You can understand things like:',
                    bullets: [
                        'Why people buy your product',
                        'How they actually use it',
                        'What they like or don\'t like',
                        'What\'s missing in the market',
                        'How you compare to competitors',
                    ],
                    conclusion: 'Basically, it shows both what people do and why they do it.',
                },
            },
            {
                title: 'Do you deliver just the raw data, or also actionable insights?',
                content: 'You get both. But more importantly, the platform turns responses into clear insights and recommendations—so you don\'t just see data, you actually understand what to do with it.',
            },
            {
                title: 'How do I get started with your usage and attitudes study?',
                content: {
                    intro: 'It\'s simple:',
                    bullets: [
                        'Define what you want to learn',
                        'Pick or customize a template',
                        'Choose your target audience',
                        'Set up your questions',
                        'Launch the study',
                    ],
                    conclusion: 'From there, everything runs in one place and you start getting insights quickly.',
                },
            },
        ],
    },
    {
        id: 'in-home-product-testing',
        meta: {
            title: 'IHUT Product Testing Services for CPG Brands | Peekage',
            description: 'Discover how consumers use your product in real life with Peekage’s IHUT testing services. Turn real feedback into actionable insights for growth.',
        },
        hero: {
            title: 'Launch Smarter. Validate Faster. Run IHUT Studies with Precision.',
            subtitle: 'IHUT Product Testing Services',
            moreContext: 'Our AI-powered IHUT product testing service delivers unmatched speed, high-quality data, and actionable insights to help you validate products and de-risk your launch with confidence.',
            image: 'caseStudies/usecases/ihut/ihut-hero.png',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'Turn In-Home Testing Into Product Validation',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'Understand how your product performs in real homes, from first impression to everyday use, with our IHUT testing services. We manage the entire research process end-to-end, from recruiting qualified participants to managing shipping and logistics to delivering actionable insights. Our AI-powered approach captures authentic consumer behavior, uncovers hidden pain points, and gives you the data you need to validate your product before launch.',
                bullets: [
                    'See how people naturally use your product in real-life settings',
                    'Identify friction points and areas for improvement before going to market',
                    'Test, learn, and refine with confidence using reliable consumer feedback',
                ],
                image: 'caseStudies/usecases/ihut/single-feature.png',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'What Can You Test With IHUT?',
                description: '',
                iconWidth: 40,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/cocktail-streamline-flex.svg',
                        title: 'Food & Beverage Products',
                        caption: 'In-home usage testing captures how real people experience your product at the table, not in a sterile focus group room.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/ice-cream-2-streamline-flex.svg',
                        title: 'Personal Care & Beauty',
                        caption: 'IHUT testing lets consumers build a routine with your product and tell you honestly how it performs over days, not minutes.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/home-2-streamline-flex.svg',
                        title: 'Household Products',
                        caption: 'In-home product testing reliably answers the questions that only come up in real cleaning situations daily.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/application-add-streamline-flex.svg',
                        title: 'New Formulas or Prototypes',
                        caption: 'Our IHUT product testing services give you a direct comparison between your old and new formula through real consumer experience.',
                    },
                ],
            },
            {
                title: 'How In-Home Usage Testing Helps Your Brand',
                description: '',
                iconWidth: 40,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/check-square-streamline-flex.svg',
                        title: 'Validate Before You Launch',
                        caption: 'Skip the expensive post-launch fixes. Our IHUT product testing services surface problems while you still have time to solve them.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/toilet-sign-man-streamline-flex.svg',
                        title: 'Sensory Test with Your Buyer Persona',
                        caption: 'Test key sensory attributes, taste, texture, scent, appearance with your target consumers to see if they match personal preferences.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/happy-face-streamline-flex.svg',
                        title: 'Collect Feedback Across the Full Experience',
                        caption: 'From first impression to final use, our in-home product testing services track satisfaction at every stage, not just a single moment in time.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/one-finger-tap-streamline-flex.svg',
                        title: 'Validate Product Claims',
                        caption: 'Test your claims against real consumer experience in real-life use. IHUT helps confirm whether your product delivers on key promises, so you can support messaging with credible, evidence-based insight before launch.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/heart-streamline-flex.svg',
                        title: 'Make Confident Positioning Decisions',
                        caption: 'Learn how consumers describe your product, what they value most, and how much they are willing to pay. That insight helps your team develop sharper positioning and more effective messaging.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/ihut/magnifying-glass-streamline-flex.svg',
                        title: 'Benchmark Against Competitors',
                        caption: 'Compare your product side by side with competitors in real-world conditions with our competitive IHUT testing services. See where you lead, where you fall short, and how to improve before launch.',
                    },
                ],
            },
        ],
        features: {
            title: 'The Advantages of IHUT Product Testing Services Your Brand Needs',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Unbiased Feedback from Real-world Experiences',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'People behave differently in artificial settings than in their own homes. In-home usage testing captures genuine reactions in the environment where your product will actually be used.',
                    image: 'caseStudies/usecases/ihut/feature-1.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Reach the Right Testers, Anywhere in North America',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'IHUT helps you reach the consumers who matter most to your brand, no matter how niche your audience or where they live. With 200+ targeting attributes, we identify participants based on demographics, preferences, dietary restrictions, shopping habits, and more.',
                    image: 'caseStudies/usecases/ihut/feature-2.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'Track Product Experience Over Full Usage Period',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Some products need a week to show their value. Others need a month. IHUT is built for extended testing periods that match the real lifecycle of your product revealing repeat usage, habit formation, and delayed reactions.',
                    image: 'caseStudies/usecases/ihut/feature-3.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 4,
                    title: 'Data That Drives Decisions, Not Debates',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Instead of biased internal opinions or guesswork, make better decisions with structured feedback from targeted consumers, building stakeholder alignment and shortening decision cycles.',
                    image: 'caseStudies/usecases/ihut/feature-4.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations. With a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines. This valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'community/community.png',
                    imageAlt: 'Our community',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ]
        },
        howItWorks: {
            title: 'How In-Home Product Testing Works with Peekage',
            items: [
                {
                    id: 1,
                    image: 'insights/howItWorks/1.png',
                    title: 'Define Your Research Goals',
                    description: 'We start by understanding exactly what you need to learn. New product or reformulation? Packaging change or pricing test? The research objective shapes everything that follows.',
                },
                {
                    id: 2,
                    image: 'insights/howItWorks/2.png',
                    title: 'Design Your Study',
                    description: 'Use Peekage\'s smart templates to build a study including study type, configuration, and survey that matches your goals in just a few clicks with no prior research experience required.',
                },
                {
                    id: 3,
                    image: 'insights/howItWorks/3.png',
                    title: 'Recruit the Right Testers',
                    description: 'We identify and recruit participants who match your real target audience, filtered by demographics, usage habits, category behavior, and geography.',
                },
                {
                    id: 4,
                    image: 'insights/howItWorks/4.png',
                    title: 'Build and Ship Product Kits',
                    description: 'Each tester receives a professionally prepared package with your product, clear usage instructions, and any relevant background information, nothing left to chance.',
                },
                {
                    id: 5,
                    image: 'insights/howItWorks/5.png',
                    title: 'Guided Testing Period',
                    description: 'Participants use your product over a defined period, with structured prompts and check-ins to capture feedback at the moments that matter most.',
                },
                {
                    id: 6,
                    image: 'insights/howItWorks/6.png',
                    title: 'Collect Consumer Feedback',
                    description: 'We gather structured responses at the end of the usage period, covering satisfaction, purchase intent, improvement ideas, and overall impressions, through online surveys and follow-up calls.',
                },
                {
                    id: 7,
                    image: 'insights/howItWorks/7.png',
                    title: 'Analyze and Deliver Insights',
                    description: 'You receive a clear, decision-ready report: what worked, what didn\'t, what consumers said unprompted, and what your next move should be.',
                },
            ]
        },
        customerStories: {
            stories: [
                {
                    image: 'caseStudies/picture/bellwether-farms.png',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;"><span style="color: #11676A;">Winning Key Retailers </span>Through Consumer Persona Insights</span>',
                    uri: '/',
                    alt: 'Wise Snacks consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/tribe9.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">How Consumer Testing Helped YumButter Optimize Packaging for <span style="color: #FF8524;">Bigger Impact</span> and Better ROI</span>',
                    uri: '/',
                    alt: 'Tribe9Foods consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/wise-snacks.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks Cuts Research Costs <span style="color: #F78834;">by 70% </span>and Speeds Up IHUT 4X</span>',
                    uri: '/',
                    alt: 'Bellwether customer insights case study',
                },
            ]
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage’s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            title: 'Related Resource',
            items: [
            {
                image: 'caseStudies/usecases/ihut/how-ihut/how-ihut-in-home-product-testing-works-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-ihut-in-home-product-testing-works">In-Home Usage Testing (IHUT): A Complete Guide for Brands</a></h3></div>',
                uri: '/in-home-product-testing/how-ihut-in-home-product-testing-works',
                alt: 'IHUT: A Complete Guide for Brands',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-recruit/how-to-recruit-real-consumers-to-test-cpg-product-in-home-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-recruit-real-consumers-to-test-cpg-product-in-home">How to Recruit Consumers for In-Home Product Testing</a></h3></div>',
                uri: '/in-home-product-testing/how-to-recruit-real-consumers-to-test-cpg-product-in-home',
                alt: 'How to Recruit Consumers for In-Home Product Testing',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut/how-to-run-ihut-card-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-test-cpg-product-with-real-consumers-before-launch">How to Test CPG Products with Real Consumers Before Launch</a></h3></div>',
                uri: '/in-home-product-testing/how-to-test-cpg-product-with-real-consumers-before-launch',
                alt: 'How to Test CPG Products with Real Consumers Before Launch',
            },
            {
                image: 'caseStudies/usecases/ihut/clt-vs-ihut/clt-vs-ihut-card-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-cpg-product">How to Run an In-Home Usage Test for Your CPG Product</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-cpg-product',
                alt: 'How to Run an In-Home Usage Test for Your CPG Product',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-send-cpg-product-prototypes/how-to-send-cpg-product-prototypes-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-send-cpg-product-prototypes">How to Send CPG Product Prototypes to Testers for an IHUT Study</a></h3></div>',
                uri: '/in-home-product-testing/how-to-send-cpg-product-prototypes',
                alt: 'How to Send CPG Product Prototypes to Testers for an IHUT Study',
            },
            {
                image: 'caseStudies/usecases/ihut/clt-vs-ihut/clt-vs-ihut-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/clt-vs-ihut">CLT vs IHUT: Which Product Testing Method Should You Choose?</a></h3></div>',
                uri: '/in-home-product-testing/clt-vs-ihut',
                alt: 'CLT vs IHUT: Which Product Testing Method Should You Choose?',
            },
            {
                image: 'caseStudies/usecases/ihut/how-many-participants/how-many-participants-ihut-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-many-participants-you-need-for-ihut">How Many Participants Do You Need for an IHUT Study?</a></h3></div>',
                uri: '/in-home-product-testing/how-many-participants-you-need-for-ihut',
                alt: 'How Many Participants Do You Need for an IHUT Study?',
            },
            {
                image: 'caseStudies/usecases/ihut/focus-groups-vs-surveys-vs-ihut/focus-groups-vs-surveys-vs-ihut-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/focus-groups-vs-surveys-vs-ihut">Focus Groups vs Surveys vs IHUT: Which Research Method Is Right for You?</a></h3></div>',
                uri: '/in-home-product-testing/focus-groups-vs-surveys-vs-ihut',
                alt: 'Focus Groups vs Surveys vs IHUT: Which Research Method Is Right for You?',
            },
            {
                image: 'caseStudies/usecases/ihut/how-much-ihut-costs/how-much-ihut-costs-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-much-ihut-costs">How Much Does IHUT Cost? A Complete Pricing Breakdown</a></h3></div>',
                uri: '/in-home-product-testing/how-much-ihut-costs',
                alt: 'How Much Does IHUT Cost? A Complete Pricing Breakdown',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-interpret-ihut-reports/how-to-interpret-ihut-reports-article-link-card-image-v2.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-interpret-ihut-reports">How to Interpret IHUT Reports: A Step-by-Step Guide</a></h3></div>',
                uri: '/in-home-product-testing/how-to-interpret-ihut-reports',
                alt: 'How to Interpret IHUT Reports: A Step-by-Step Guide',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-build-targeted-consumer-list-for-ihut/how-to-build-targeted-consumer-list-for-ihut-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-build-targeted-consumer-list-for-ihut">How to Build a Targeted Consumer List for In-Home Usage Testing</a></h3></div>',
                uri: '/in-home-product-testing/how-to-build-targeted-consumer-list-for-ihut',
                alt: 'How to Build a Targeted Consumer List for In-Home Usage Testing',
            },
            {
                image: 'caseStudies/usecases/ihut/ihut-survey-questions/ihut-survey-questions-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/ihut-survey-questions">In-Home Usage Test Survey Questions to Ask Consumers</a></h3></div>',
                uri: '/in-home-product-testing/ihut-survey-questions',
                alt: 'In-Home Usage Test Survey Questions to Ask Consumers',
            },
            {
                image: 'caseStudies/usecases/ihut/ihut-report-templates/ihut-report-templates-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/ihut-report-templates">IHUT Report Templates: How to Structure Your In-Home Usage Testing Results</a></h3></div>',
                uri: '/in-home-product-testing/ihut-report-templates',
                alt: 'IHUT Report Templates: How to Structure Your In-Home Usage Testing Results',
            },
            {
                image: 'caseStudies/usecases/ihut/what-consumer-drivers-brands-should-test-with-ihut/what-consumer-drivers-brands-should-test-with-ihut-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/what-consumer-drivers-brands-should-test-with-ihut">What Consumer Drivers Should Brands Test With IHUT?</a></h3></div>',
                uri: '/in-home-product-testing/what-consumer-drivers-brands-should-test-with-ihut',
                alt: 'What Consumer Drivers Should Brands Test With IHUT?',
            },
            {
                image: 'caseStudies/usecases/ihut/how-ihut-works-for-food-beverage-products/how-ihut-works-for-food-beverage-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-ihut-works-for-food-beverage-products">How In-Home Product Testing Works for Food and Beverage Products</a></h3></div>',
                uri: '/in-home-product-testing/how-ihut-works-for-food-beverage-products',
                alt: 'How In-Home Product Testing Works for Food and Beverage Products',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut-for-pet-products/how-to-run-ihut-for-pet-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-pet-products">How to Run an IHUT Study for Pet Products</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-pet-products',
                alt: 'How to Run an IHUT Study for Pet Products',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut-for-refrigerated-frozen-products/how-to-run-ihut-for-refrigerated-frozen-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-refrigerated-frozen-products">How to Run an In-Home Usage Test for Refrigerated and Frozen Products</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-refrigerated-frozen-products',
                alt: 'How to Run an In-Home Usage Test for Refrigerated and Frozen Products',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut-for-beauty-and-personal-care-products/how-to-run-ihut-for-beauty-and-personal-care-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-beauty-and-personal-care-products">How to Run an IHUT Study for Beauty and Personal Care Products</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-beauty-and-personal-care-products',
                alt: 'How to Run an IHUT Study for Beauty and Personal Care Products',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut-for-wellness-supplement-products/how-to-run-ihut-for-wellness-supplement-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-wellness-supplement-products">How to Run an IHUT for Wellness and Supplement Products</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-wellness-supplement-products',
                alt: 'How to Run an IHUT for Wellness and Supplement Products',
            },
            {
                image: 'caseStudies/usecases/ihut/how-to-run-ihut-for-baby-products/how-to-run-ihut-for-baby-products-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/how-to-run-ihut-for-baby-products">How to Plan an IHUT for Baby Products From Recruitment to Feedback</a></h3></div>',
                uri: '/in-home-product-testing/how-to-run-ihut-for-baby-products',
                alt: 'How to Plan an IHUT for Baby Products From Recruitment to Feedback',
            },
            {
                image: 'caseStudies/usecases/ihut/methods-ihut/methods-ihut-banner.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing/methods-ihut">What Are the Different Methods of IHUT and How Do They Work?</a></h3></div>',
                uri: '/in-home-product-testing/methods-ihut',
                alt: 'What Are the Different Methods of IHUT and How Do They Work?',
            },
            ],
        },
        faqItems: [
            {
                title: 'What is in-home usage testing (IHUT)?',
                content:
                    'IHUT or in-home product testing, is a market research method where real consumers test your product inside their own homes and report their honest experience. Unlike lab testing, IHUT captures how your product performs in real-world conditions.',
            },
            {
                title: 'How long does an IHUT campaign take?',
                content:
                    'Most IHUT campaigns take between 1 to 2 weeks, depending on the product type, usage period, and research depth. This includes setup, participant recruitment, product shipping, testing time, and final analysis.',
            },
            {
                title: 'How many participants do I need for IHUT testing?',
                content:
                    'The number of participants typically ranges from 30 to 200+, depending on your goals. Smaller samples are useful for directional insights, while larger groups provide more statistically reliable results.',
            },
            {
                title: 'Can IHUT test products that aren\'t launched yet?',
                content:
                    'Yes, IHUT is ideal for pre-launch testing. It allows you to gather real user feedback, identify potential issues, and refine your product before it reaches the market.',
            },
            {
                title: 'What methods are included in your IHUT product testing services?',
                content:
                    'Our IHUT services can include surveys, diaries, photo/video submissions, and follow-up questionnaires. We customize the methodology based on your product and research objectives.',
            },
            {
                title: 'What kinds of feedback does IHUT collect?',
                content:
                    'IHUT captures both quantitative and qualitative feedback, including usability, product performance, satisfaction, preferences, and overall experience in real-life conditions.',
            },
            {
                title: 'Are IHUT product testing services only for large brands?',
                content:
                    'No, IHUT is suitable for businesses of all sizes, from startups to established brands. We customize the scope based on your budget and needs.',
            },
            {
                title: 'How do you ensure response quality?',
                content:
                    'We ensure high-quality responses through careful participant screening, clear instructions, consistency checks, and data validation techniques. We also monitor engagement and remove low-quality or incomplete responses during analysis.',
            },
        ],
    },
    {
        id: 'claims-testing',
        meta: {
            title: 'Claims Testing Services That Proves Every Product Promise | Peekage',
            description: 'Peekage’s claims testing services help you see if your product, packaging, and ad claims actually resonate, build trust, and drive real results.',
        },
        hero: {
            title: 'Claims Testing Backs Every Word You Put on Your Product',
            subtitle: 'Claims Testing Services',
            moreContext: 'Every claim you make through your packaging, ads, or product copy is a promise to your consumer. Peekage\'s claims testing service ensures those promises resonate, convert, and stand up to scrutiny.',
            image: 'caseStudies/usecases/claims-testing-services/hero.png',
            imageAlt: 'Claims testing services for CPG product packaging and marketing claims',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'Turn Consumer Perception Into Your Strongest Marketing Asset',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'A great product isn\'t enough if the words describing it don\'t connect. Claims testing is the research process that identifies which messages truly resonate with your target consumers, and provides the substantiation data to back them up. At Peekage, we help brands find the claims that drive real purchase intent, not just the ones that sound good in a boardroom.',
                bullets: [
                    'Test multiple claim options against real consumers in your target market',
                    'Identify which messages drive the highest purchase intent and brand trust',
                    'Gather legally defensible substantiation data before going to market',
                    'Eliminate guesswork from your packaging, advertising, and launch copy',
                    'Prioritize the handful of claims that actually shift consumer behavior',
                ],
                image: 'caseStudies/usecases/claims-testing-services/single-feature.png',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'What Can Claims Testing Evaluate for Your Brand?',
                description: '',
                iconWidth: 40,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/big-checkmark.svg',
                        title: 'On-Package Marketing Claims',
                        caption: 'Before any word go on your label, our claims testing services will tell you which ones consumers find credible and worth paying for.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/mail.svg',
                        title: 'Advertising & Campaign Messaging',
                        caption: 'Claims testing validates which messages cut through, which fall flat, and which could mislead  before you spend your budget.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/signal.svg',
                        title: 'Comparative & Competitive Claims',
                        caption: 'Our claims testing services give you the consumer-backed data needed to make comparative statements with accuracy.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/thumb-up.svg',
                        title: 'Sustainability & Ingredient Claims',
                        caption: 'Claims testing ensures your sustainability messaging is both believable and verifiable, not just aspirational.',
                    },
                ],
            },
            {
                title: 'How Claims Testing Helps Your Brand Win',
                description: '',
                iconWidth: 40,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/big-checkmark.svg',
                        title: 'Find the Words That Actually Sell',
                        caption: 'Claims testing ranks your options so you lead with the message that drives the most purchase intent, not the one that just sounds best internally.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/user-collaborate.svg',
                        title: 'Understand Real Usage Behavior',
                        caption: 'Peekage\'s claims testing service generates the kind of credible and consumer-backed evidence that holds up under scrutiny.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/chat-bubble-typing.svg',
                        title: 'Align Messaging With Consumer Needs',
                        caption: 'Claims testing helps marketers align messaging with consumer needs and aspirations at the right moment in the customer journey.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/return-square.svg',
                        title: 'Reduce Wasted Marketing Spend',
                        caption: 'Claims testing services will tell you what converts before you commit to production, packaging runs, or ad buys.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/thumb-up.svg',
                        title: 'Build Long-Term Consumer Trust',
                        caption: 'The best claims succeed in convincing consumers that a product is the one to purchase while simultaneously building brand equity.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/claims-testing-services/magic-wand.svg',
                        title: 'Test Multiple Claims in One Study',
                        caption: 'Rather than running separate research cycles, Peekage can evaluate a full set of candidate claims in a single study.',
                    },
                ],
            },
        ],
        features: {
            title: 'The Real Advantages of Running Claims Testing Before Launch',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Consumer-Validated, Not Committee-Approved',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Internal teams are too close to the product. Claims testing service replaces opinion debates with actual data from the people who will be buying, giving your launch decisions a foundation that internal alignment never can.',
                    image: 'caseStudies/usecases/claims-testing-services/feature-1.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Defensible Data When It Matters Most',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Claims substantiation is the process of ensuring supporting evidence is in place for statements made in advertisements, point-of-sale materials, sales brochures, and product packaging.',
                    image: 'caseStudies/usecases/claims-testing-services/feature-2.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'Clarity Before You\'re Committed',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Packaging reprints, campaign overhauls, and product recalls are expensive. Running claims testing before locking in production decisions costs a fraction of fixing a messaging mistake after launch.',
                    image: 'caseStudies/usecases/claims-testing-services/feature-3.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 4,
                    title: 'Works Across Every Stage of the Product Lifecycle',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Claims testing isn\'t just a pre-launch tool. If you\'re refreshing an existing product, entering a new market, or repositioning a brand, testing your messaging against current consumer expectations keeps you relevant at every stage.',
                    image: 'caseStudies/usecases/claims-testing-services/feature-4.png',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 5,
                    title: 'Sharpen Your Competitive Edge on the Shelf',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'When every brand in your category is making bold promises, the one with tested, proven, consumer-backed claims stands out. Our claims testing services give you the confidence to position more aggressively, and the data to do it credibly, right where purchase decisions are made.',
                    image: 'caseStudies/usecases/claims-testing-services/feature-5.png',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations. With a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines. This valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'community/community.png',
                    imageAlt: 'Peekage community of engaged consumers available for claims testing research',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ]
        },
        howItWorks: {
            title: 'How Claims Testing Works with Peekage',
            items: [
                {
                    id: 1,
                    image: 'insights/howItWorks/1.png',
                    title: 'Define Your Research Goals',
                    description: 'We start by understanding what you need your claims to achieve, whether that\'s driving trial, justifying a premium price, highlighting a key ingredient, or outpositioning a competitor.',
                },
                {
                    id: 2,
                    image: 'insights/howItWorks/2.png',
                    title: 'Identify and Shortlist Candidate Claims',
                    description: 'Working with your team, we help organize and structure your candidate claims , ensuring each one is specific, testable, and legally sound before consumer evaluation begins.',
                },
                {
                    id: 3,
                    image: 'insights/howItWorks/3.png',
                    title: 'Recruit Your Target Audience',
                    description: 'We recruit real consumers who match your actual buyer profile, filtered by category usage, demographics, purchase behavior, and any other criteria relevant to your product and market.',
                },
                {
                    id: 4,
                    image: 'insights/howItWorks/4.png',
                    title: 'Run Structured Consumer Testing',
                    description: 'Using proven methodologies including MaxDiff ranking and monadic testing, participants evaluate your claims against the product itself, rating credibility, appeal, clarity, and purchase influence.',
                },
                {
                    id: 5,
                    image: 'insights/howItWorks/5.png',
                    title: 'Collect Substantiation-Grade Data',
                    description: 'We gather statistically sound, documented responses that meet the standards required for regulatory and legal substantiation, not just directional insights, but defensible research.',
                },
                {
                    id: 6,
                    image: 'insights/howItWorks/6.png',
                    title: 'Deliver a Clear Claims Recommendation',
                    description: 'You receive a prioritized report: which claims performed best, why, how different consumer segments responded, and exactly what language to lead with across packaging and marketing.',
                },
            ]
        },
        customerStories: {
            stories: [
                {
                    image: 'caseStudies/picture/bellwether-farms.png',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;"><span style="color: #11676A;">Winning Key Retailers </span>Through Consumer Persona Insights</span>',
                    uri: '/case-studies',
                    alt: 'Bellwether Farms consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/tribe9.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">How Consumer Testing Helped YumButter Optimize Packaging for <span style="color: #FF8524;">Bigger Impact</span> and Better ROI</span>',
                    uri: '/case-studies',
                    alt: 'Tribe9 YumButter packaging testing case study',
                },
                {
                    image: 'caseStudies/picture/wise-snacks.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks Cuts Research Costs <span style="color: #F78834;">by 70% </span>and Speeds Up IHUT 4X</span>',
                    uri: '/case-studies',
                    alt: 'Wise Snacks IHUT consumer insights case study',
                },
            ]
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage’s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            title: 'Related Resource',
            items: [
            {
                image: 'caseStudies/usecases/claims-testing-services/what-is-claims-testing/what-is-claims-testing-article-link-card-image.png',
                description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/claims-testing/what-is-claims-testing">What Is Claims Testing: Complete Guide</a></h3></div>',
                uri: '/claims-testing/what-is-claims-testing',
                alt: 'Woman writing in a notebook beside a laptop while researching product claims',
            },
            ],
        },
        faqItems: [
            {
                title: 'What types of claims can be tested with Peekage?',
                content:
                    'We can test performance claims, comparative claims, ingredient and formulation claims, sustainability claims, and consumer preference claims across packaging, digital advertising, retail materials, and campaign copy.',
            },
            {
                title: 'How long does a claims testing study take?',
                content:
                    'Studies typically take just a few days from launch to results, depending on the size of your audience and the complexity of your campaign.',
            },
            {
                title: 'How easy is it to interpret the results from a claims testing campaign?',
                content:
                    'Very easy. Peekage presents results in clear, actionable reports with visualizations and insights, allowing you to quickly understand which claims resonate and which may need refinement.',
            },
            {
                title: 'Can I run claims testing campaigns on the Peekage platform on my own, or will I need support from your team?',
                content:
                    'You can run campaigns independently using our intuitive platform. If you prefer, our team is also available to provide guidance and best practices.',
            },
            {
                title: 'Do I need to create my claims test from scratch, or are templates available?',
                content:
                    'You don\'t need to start from scratch. Peekage offers pre-built templates for common claims testing scenarios, which you can use as-is or adapt to your needs.',
            },
            {
                title: 'How customisable are the claims testing templates on the platform?',
                content:
                    'The templates are highly customisable. You can modify questions, claims, participant criteria, and survey logic to fit your product, audience, and campaign goals.',
            },
        ],
    },
    {
        id: 'taste-sensory-testing',
        meta: {
            title: 'Taste & Sensory Testing Services for CPG Brands | Peekage',
            description: 'Test flavor, aroma, texture and appeal of your product with real consumers. Peekage ships samples, recruits your target audience & delivers sensory insights.',
        },
        hero: {
            title: 'Perfect Your Formula Into a Product Consumers Crave',
            subtitle: 'Taste and Sensory Testing Services',
            moreContext: 'Your product is judged by all five senses, not just one. Our taste and sensory testing service puts your product in real consumers’ hands and turns their reactions to flavor, aroma, and texture into clear, actionable insights.',
            image: 'caseStudies/usecases/taste-sensory-testing/hero.png',
            imageAlt: 'Smiling consumer holding two popsicles during a taste and sensory test',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'Understand How Your Product Tastes, Smells, and Feels',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'Our taste and sensory testing services capture honest reactions across every sense, flavor, aroma, texture, mouthfeel, appearance, and aftertaste, and hand you the insight to refine your formula. We manage the entire process end-to-end, from recruiting the right consumers to shipping samples and delivering decision-ready results.',
                bullets: [
                    'Understand how consumers experience your product across every sense, not just taste',
                    'Catch what\'s too sweet, too salty, off in aroma, or wrong in texture while you can still fix it',
                    'Refine your formula using reliable, real-world sensory feedback',
                ],
                image: 'caseStudies/usecases/taste-sensory-testing/single-feature.webp',
                imageAlt: 'Consumer holding a soap bar to her eye during sensory product testing',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'What Can You Test With Our Taste and Sensory Testing Services?',
                description: '',
                iconWidth: 40,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/food-snacks.png',
                        title: 'Food & Snacks',
                        caption: 'Capture how real people experience flavor, aroma, crunch, and texture, from the first bite to the last, in their own kitchens.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/beverages.svg',
                        title: 'Beverages',
                        caption: 'Test taste, sweetness, mouthfeel, aroma, and aftertaste with the consumers who will actually reach for your drink on the shelf.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/new-formulas.svg',
                        title: 'New Formulas & Reformulations',
                        caption: 'Compare your current formula against a new one across every sensory attribute and know how it performs before you switch.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/personal-care.png',
                        title: 'Personal Care & Household Products',
                        caption: 'Evaluate scent, feel, texture, and overall sensory appeal for products where smell and touch drive the experience.',
                    },
                ],
            },
            {
                title: 'How Our Taste and Sensory Testing Services Help Your Brand',
                description: '',
                iconWidth: 40,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/refine-formula.png',
                        title: 'Refine Your Formula Before You Launch',
                        caption: 'Skip costly post-launch reformulations. Our sensory testing services show what\'s too sweet, too bitter, off in aroma, or wrong in texture while you still have time to adjust the recipe.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/sensory-attributes.png',
                        title: 'Test Every Sensory Attribute',
                        caption: 'Measure taste, aroma, texture, mouthfeel, appearance, and aftertaste with your target consumers to see how each one lands, and which ones drive or break appeal.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/compare-formulas.svg',
                        title: 'Compare Formulas Side by Side',
                        caption: 'Run head-to-head sensory comparisons between formula versions to know exactly which one consumers prefer, and why, before you commit to production.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/validate-claims.svg',
                        title: 'Validate Your Sensory Claims',
                        caption: '"Rich," "smooth," "fresh-smelling," "not too sweet" - test your claims against real sensory experiences so your messaging is backed by credible consumer evidence.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/repeat-purchase.svg',
                        title: 'Understand What Drives Repeat Purchase',
                        caption: 'Learn how consumers describe the full experience, what they love, and what would make them buy again, so you can sharpen both your product and your positioning.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/taste-sensory-testing/icons/benchmark.svg',
                        title: 'Benchmark Against Competitors',
                        caption: 'Put your product in a blind sensory test next to category leaders. See where your flavor, aroma, and texture win, where they fall short, and where to improve.',
                    },
                ],
            },
        ],
        features: {
            title: 'The Advantages of Peekage\'s Taste and Sensory Testing Services',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Real Sensory Experiences, in Real Settings',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'People experience a product differently in a lab than they do at their own table. Because taste, smell, and texture can\'t be captured through a screen, we ship real samples to real homes, so consumers experience your product the way they actually would, and you get reactions you can trust.',
                    image: 'caseStudies/usecases/taste-sensory-testing/feature-1.webp',
                    imageAlt: 'Consumer tasting a product sample at home during sensory testing',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Reach the Right Consumers, Anywhere in North America',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Sensory preference is personal, and the right tester makes all the difference. With 200+ targeting attributes, we recruit participants by demographics, dietary preferences, category habits, and sensory profiles, so your product is judged by the people it\'s actually made for.',
                    image: 'caseStudies/usecases/taste-sensory-testing/feature-2.webp',
                    imageAlt: 'Diverse consumers evaluating products across North America',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'Capture the Full Sensory Experience',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'First impression, full serving, and the aftertaste that follows. Sensory testing captures reactions across the entire experience, flavor, aroma, texture, and appearance, not a single moment in a sterile room, revealing how appeal holds up from start to finish.',
                    image: 'caseStudies/usecases/taste-sensory-testing/feature-3.webp',
                    imageAlt: 'Consumer capturing the full sensory experience of a product at home',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 4,
                    title: 'Data That Drives Decisions, Not Debates',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Replace "I think it tastes great" with structured, quantified sensory feedback from your target consumers. Build stakeholder alignment around real data and shorten the path from formula to shelf.',
                    image: 'caseStudies/usecases/taste-sensory-testing/feature-4.webp',
                    imageAlt: 'Team reviewing quantified sensory testing insights and data',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations.\nWith a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines.\nThis valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'caseStudies/usecases/taste-sensory-testing/community.png',
                    imageAlt: 'Collage of Peekage community members testing CPG products at home',
                    imageWidth: 640,
                    imageHeight: 640,
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ],
        },
        howItWorks: {
            title: 'How Taste and Sensory Testing Works with Peekage',
            items: [
                {
                    id: 1,
                    image: 'insights/howItWorks/1.png',
                    title: 'Define Your Research Goals',
                    description: 'We start by understanding what you need to learn. New formula or reformulation? Is it the flavor, the aroma, the texture, or the balance that needs work? The sensory objective shapes everything that follows.',
                },
                {
                    id: 2,
                    image: 'insights/howItWorks/2.png',
                    title: 'Design Your Study',
                    description: 'Use Peekage\'s smart templates or the AI feature to build your study, study type, sample setup, and sensory survey, in just a few clicks, with no prior research experience required.',
                },
                {
                    id: 3,
                    image: 'insights/howItWorks/3.png',
                    title: 'Recruit the Right Panel',
                    description: 'We identify and recruit participants who match your real target audience, filtered by demographics, dietary preferences, category usage, and sensory habits.',
                },
                {
                    id: 4,
                    image: 'insights/howItWorks/4.png',
                    title: 'Build and Ship Product Samples',
                    description: 'Each tester receives a professionally prepared package with your product, clear evaluation instructions, and any details needed for a fair, consistent sensory assessment, including products with special handling needs.',
                },
                {
                    id: 5,
                    image: 'insights/howItWorks/5.png',
                    title: 'Guided Testing Period',
                    description: 'Participants experience your product under structured prompts that capture reactions at the moments that matter, first impression, full use, and the aftertaste or after-feel that follows.',
                },
                {
                    id: 6,
                    image: 'insights/howItWorks/6.png',
                    title: 'Collect Sensory Feedback',
                    description: 'We gather structured responses covering flavor, aroma, texture, mouthfeel, appearance, overall liking, and purchase intent, through online surveys and follow-up calls.',
                },
                {
                    id: 7,
                    image: 'insights/howItWorks/7.png',
                    title: 'Analyze and Deliver Insights',
                    description: 'You receive a clear, decision-ready report: which sensory attributes won, which need work, what consumers said unprompted, and exactly how to refine your formula.',
                },
            ],
        },
        customerStories: {
            stories: [
                {
                    image: 'caseStudies/picture/bellwether-farms.png',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;"><span style="color: #11676A;">Winning Key Retailers </span>Through Consumer Persona Insights</span>',
                    uri: '/case-studies',
                    alt: 'Bellwether Farms consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/egg-life.webp',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Egglife Validates Major Reformulation with Customers in 9 Days and Avoids <span style="color: #7ec5be;">$1M</span> in Production Risk</span>',
                    uri: '/case-studies',
                    alt: 'Egglife reformulation validation case study',
                },
                {
                    image: 'caseStudies/picture/wise-snacks.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks Cuts Research Costs <span style="color: #F78834;">by 70% </span>and Speeds Up IHUT 4X</span>',
                    uri: '/case-studies',
                    alt: 'Wise Snacks IHUT consumer insights case study',
                },
            ],
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage’s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            title: 'Related Resources',
            items: [
                {
                    image: 'caseStudies/usecases/taste-sensory-testing/sensory-testing-for-cpg-brands-article-link-card-image.png',
                    description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/blog/sensory-testing">Sensory Testing for CPG Brands: How to Gather Consumer Feedback and Improve Products</a></h3></div>',
                    uri: '/blog/sensory-testing',
                    alt: 'Woman in sunglasses sitting in a shopping cart and drinking from a beverage can',
                },
                {
                    image: 'caseStudies/usecases/taste-sensory-testing/ihut-product-testing-services-article-link-card-image.png',
                    description: '<div class="flex flex-col gap-3"><h3 class="font-manrope font-extrabold text-black leading-8 text-2xl"><a href="/in-home-product-testing">IHUT Product Testing Services</a></h3></div>',
                    uri: '/in-home-product-testing',
                    alt: 'Hands pouring liquid from a personal care bottle into a palm during in-home product testing',
                },
            ],
        },
        faqItems: [
            {
                title: 'What is taste and sensory testing?',
                content:
                    'Taste and sensory testing is a form of research where real consumers experience your product and evaluate it across every sense — flavor, aroma, texture, mouthfeel, appearance, and aftertaste. It tells you not just whether people like your product, but specifically what to adjust: too sweet, too salty, off in smell, wrong in texture, before you launch or reformulate.',
            },
            {
                title: 'How is sensory testing different from a focus group or central location test (CLT)?',
                content:
                    'People experience a product differently in artificial settings than in their own homes. Instead of bringing consumers into a facility, Peekage ships real samples to real homes so participants engage with your product naturally—giving you more authentic reactions, broader geographic reach, and faster turnaround than traditional CLT.',
            },
            {
                title: 'How long does a taste and sensory test take?',
                content:
                    'It depends on your product and goals, but because Peekage manages recruiting, shipping, and analysis end-to-end, many studies move from launch to insights in a matter of days, with some results available in as little as 24 hours after fieldwork.',
            },
            {
                title: 'Can you test products that aren\'t launched yet?',
                content:
                    'Yes. Sensory testing is ideal for prototypes, new formulas, and pre-launch recipes. You can validate flavor, aroma, and texture, or compare a new version against your current one—before committing to production.',
            },
            {
                title: 'What sensory attributes can you measure?',
                content:
                    'We capture the full sensory experience: taste and flavor intensity, sweetness and saltiness balance, aroma and smell, mouthfeel and texture, appearance, and aftertaste, plus overall liking, purchase intent, and open-ended feedback in consumers\' own words.',
            },
            {
                title: 'Do you handle shipping of food and perishable samples?',
                content:
                    'Yes. Peekage manages end-to-end fulfillment, including products with special handling and perishability requirements, so your samples reach testers in the right condition for a fair evaluation.',
            },
            {
                title: 'Are taste and sensory testing services only for large brands?',
                content:
                    'No. Brands of any size get big-research-firm quality at a fraction of the cost—no in-house research team required.',
            },
        ],
    },
    {
        id: 'customer-segmentation',
        meta: {
            title: 'Customer Segmentation Analysis Services | Peekage',
            description: 'Build precise customer segments and ideal buyer personas with real consumer data. Target from 200+ attributes and profile your audience, no research team needed.',
        },
        hero: {
            title: 'Build Precise Customer Segments and Ideal Buyer Personas',
            subtitle: 'Customer Segmentation Services',
            moreContext: 'Our customer segmentation service turns real consumer data into detailed buyer personas, so you know exactly who your ideal customer is, what drives them, and how to reach them.',
            image: 'caseStudies/usecases/customer-segmentation/hero.webp',
            imageAlt: 'Consumer pouring product into her hand during customer segmentation research',
            btnText: 'Talk to an Expert',
            url: '/contact?talk-to-an-expert=true',
        },
        singleFeature: [
            {
                url: '/contact?talk-to-an-expert=true',
                isSpecialButton: false,
                isPrimaryButton: true,
                hasBottomDivider: true,
                title: 'Turn Consumer Data Into Buyer Personas You Can Act On',
                tag: 'h2',
                descriptionTag: 'p',
                intro: 'You can\'t build the right product or write the right message for a customer you don\'t understand. Our customer segmentation and buyer persona identification helps you build detailed profiles of your ideal customers, their demographics, behaviors, motivations, and challenges.',
                bullets: [
                    'Refine your segmentation to identify the key audiences',
                    'Understand what motivates your customers and how they make purchase decisions',
                    'Tailor your product, positioning, and marketing to the people most likely to buy',
                ],
                image: 'caseStudies/usecases/customer-segmentation/single-feature-jar.webp',
                imageAlt: 'Consumer holding a product jar during buyer persona research',
                // Match hero media frame: square box + same max-width tokens.
                mediaClass: 'aspect-square w-full max-w-hero-media-sm md:max-w-hero-media',
                buttonTitle: 'Talk to an Expert',
                class: 'nth-reverse',
                aos: {
                    content: 'fade-in',
                    image: 'fade-in',
                },
            },
        ],
        insightIns: [
            {
                title: 'Why Choose Peekage\'s Customer Segmentation Analysis Services?',
                description: '',
                iconWidth: 40,
                gridCols: 4,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/first-party.png',
                        title: 'A First-Party Consumer Network You Can Trust',
                        caption: 'Instead of borrowed third-party data, Peekage uses its own community of 5M+ real, engaged shoppers, so your segments reflect the market you\'re actually selling to.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/beyond-demographics.png',
                        title: 'Depth That Goes Beyond Demographics',
                        caption: 'With 200+ attributes, we build rich, multi-dimensional segments that show not just who your customers are, but why they choose your products.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/behavior-grounded.png',
                        title: 'Segments Grounded in Behavior to Hold Up',
                        caption: 'Opinion-based segments often fail in the real world. We validate ours against actual behavior, making each segment a reliable predictor of purchasing decisions.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/clear-personas.png',
                        title: 'Clear Personas You Can Act on Immediately',
                        caption: 'Raw segments are only half the job. Our AI assistant turns customer segmentation analysis into ready-to-use personas with clear recommendations your team can act on.',
                    },
                ],
            },
            {
                title: 'How Our Customer Segmentation Analysis Services Help Your Brand',
                description: '',
                iconWidth: 40,
                gridCols: 3,
                values: [
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/pinpoint.png',
                        title: 'Pinpoint Your Ideal Buyer Persona',
                        caption: 'We identify the segments most likely to buy, stay, and spend more, so you can build a clear, data-backed persona instead of guessing.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/positioning.png',
                        title: 'Improve Positioning and Messaging',
                        caption: 'By understanding what each group values, you can tailor your claims and creative to speak directly to the people who matter most.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/help-target-shoppers.svg',
                        title: 'Target the Right Shoppers with Every Campaign',
                        caption: 'Whether it\'s a sampling program, launch, or paid push, segmentation tells you exactly who to reach, cutting waste and improving results.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/growth.png',
                        title: 'Uncover New Growth Opportunities',
                        caption: 'Segmentation reveals high-potential audiences you\'re already winning, or ones competitors ignore, so you can expand with a clear strategy.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/purchasing.png',
                        title: 'Identify Purchasing Behaviors',
                        caption: 'Map how, where, and how often your audience shops, from channel preferences to purchase frequency, and align your strategy to their real habits.',
                    },
                    {
                        iconPath: 'images/caseStudies/usecases/customer-segmentation/icons/compare-segments.png',
                        title: 'Compare Multiple Segments Side by Side',
                        caption: 'Build and profile several audience segments in one study to see exactly how their needs, behaviors, and motivations differ and where the biggest opportunity sits.',
                    },
                ],
            },
        ],
        features: {
            title: 'The Advantages of Peekage\'s Customer Segmentation and Buyer Persona Identification Services',
            caption: '',
            features: [
                {
                    id: 1,
                    title: 'Higher Return on Your Marketing Spend',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'When you know exactly who to target, you stop paying to reach people who\'ll never convert. Brands use customer segmentation to concentrate budget on the groups that drive the most value, focusing sampling, advertising, and retail support where they\'ll actually pay off. Over time, that precision lifts ROI and makes every dollar work harder.',
                    image: 'caseStudies/usecases/customer-segmentation/feature-1.webp',
                    imageAlt: 'Young adults enjoying beverages together, representing high-value customer segments',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 2,
                    title: 'Fast and More Confident Decisions',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Instead of waiting weeks for a traditional research report, you get clear segment insights in days. That speed lets your team act while the opportunity is still fresh, rather than reacting after the moment has passed. And because the insights are grounded in real shopper behavior, you can move forward with data behind you instead of relying on gut feel.',
                    image: 'caseStudies/usecases/customer-segmentation/feature-2.webp',
                    imageAlt: 'Consumer applying skincare product during segment research',
                    class: 'nth-reverse',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
                {
                    id: 3,
                    title: 'Better Product-Market Fit',
                    tag: 'h3',
                    descriptionTag: 'p',
                    content: 'Aligning your product, packaging, and pricing with the segments most likely to love them leads to stronger trial and fewer missteps. When the right people meet the right product, you see better reviews, higher repeat purchase rates, and steadier growth. Segmentation helps you find that fit before you invest heavily, not after.',
                    image: 'caseStudies/usecases/customer-segmentation/feature-3.webp',
                    imageAlt: 'Hands breaking apart a snack product during product-market fit testing',
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                },
            ],
        },
        oldFeature: {
            features: [
                {
                    id: 1,
                    title: 'Exclusive community of high value consumers',
                    headline: 'Representative Community of Consumers',
                    content: 'Peekage has a community of vibrant and highly engaged shoppers from diverse backgrounds who join Peekage to test new products and innovations.\nWith a passion for trying new things, they willingly share their opinions and insights, including shopping habits, dietary preferences, interests, and routines.\nThis valuable information enables you to recruit a diverse and representative sample of your target audience. Once matched with your research, they provide feedback on concepts, products, or packaging through surveys and interviews.',
                    image: 'caseStudies/usecases/customer-segmentation/community.png',
                    imageAlt: 'Collage of Peekage community members testing CPG products at home',
                    imageWidth: 640,
                    imageHeight: 640,
                    class: '',
                    aos: {
                        content: 'fade-in',
                        image: 'fade-in',
                    },
                    component: 'FeatureItem',
                    url: '/natural-shoppers-community',
                    buttonTitle: 'Meet our community',
                    isSpecialButton: true,
                },
            ],
        },
        howItWorks: {
            title: 'Peekage\'s Process for Segmentation Analysis Services',
            items: [
                {
                    id: 1,
                    image: 'insights/howItWorks/1.png',
                    imageAlt: 'Step 1 illustration for defining customer segmentation research goals',
                    title: 'Define Your Research Goals',
                    description: 'We start with a short kickoff to pin down what you want to learn (for example, "who are our highest-value buyers?") and which marketing, product, or sales decisions the segments will inform. This keeps your entire customer segmentation analysis focused on outcomes that matter to your business.',
                },
                {
                    id: 2,
                    image: 'insights/howItWorks/2.png',
                    imageAlt: 'Step 2 illustration for choosing a buyer persona study type in Peekage',
                    title: 'Pick Your Study Type in Peekage',
                    description: 'Choose your study type to match your goal. For segmentation and profiling, the Buyer Persona Identification template gives you a good starting point built to surface demographics, behaviors, motivations, and challenges, so you gather insights you can actually act on.',
                },
                {
                    id: 3,
                    image: 'insights/howItWorks/3.png',
                    imageAlt: 'Step 3 illustration for building a research panel with 200-plus attributes',
                    title: 'Build Your Panel Using 200+ Attributes',
                    description: 'Define precise demographic, behavioral, and geographic criteria to reach exactly the right audience. Peekage\'s panel includes over 200 targeting attributes, from demographics to dietary preferences and lifestyle, so you can build and compare well-defined segments.',
                },
                {
                    id: 4,
                    image: 'insights/howItWorks/4.png',
                    imageAlt: 'Step 4 illustration for designing or reviewing an AI-assisted segmentation survey',
                    title: 'Design Your Survey or Review the One Built by AI',
                    description: 'Design your survey by asking the right questions about purchase motivation, decision factor, shopping habits, brand familiarity, and more. Instead of building from scratch, use Peekage\'s pre-built templates to save time and stay consistent, or let Peekage\'s AI design the survey for you. If you use AI, review the questions before launching to make sure they meet your objectives.',
                },
                {
                    id: 5,
                    image: 'insights/howItWorks/5.png',
                    imageAlt: 'Step 5 illustration for Peekage review and launching a segmentation campaign',
                    title: 'Send for Peekage Review and Launch Your Campaign',
                    description: 'Once you submit, Peekage reviews your customer segmentation study for potential issues and verifies it\'s set up to collect accurate data. After approval, the Peekage execution AI agent begins recruitment and data collection, while the quality agent ensures high-quality responses. The live dashboard shows results instantly as they come in.',
                },
            ],
        },
        customerStories: {
            stories: [
                {
                    image: 'caseStudies/picture/bellwether-farms.png',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Winning Key Retailers Through Consumer Persona Insights</span>',
                    uri: '/case-studies',
                    alt: 'Bellwether Farms consumer insights case study',
                },
                {
                    image: 'caseStudies/picture/tribe9.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">How Consumer Testing Helped YumButter Optimize Packaging for Bigger Impact and Better ROI</span>',
                    uri: '/case-studies',
                    alt: 'Tribe9 YumButter packaging testing case study',
                },
                {
                    image: 'caseStudies/picture/wise-snacks.jpg',
                    description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks Cuts Research Costs by 70% and Speeds Up IHUT 4X</span>',
                    uri: '/case-studies',
                    alt: 'Wise Snacks IHUT consumer insights case study',
                },
            ],
        },
        whyPeekage: {
            enabled: true,
            items: [
                {
                    title: 'Streamlined Process',
                    image: 'insights/whyPeekage/postSamplingAction.svg',
                    content: 'Peekage is vertically integrated across the entire research workflow. With AI-assisted automation at every step, all processes run smoothly from start to finish.',
                },
                {
                    title: 'Proprietary Panel',
                    image: 'insights/whyPeekage/collectData.svg',
                    content: 'Proprietary panel of 5 million consumers, representative of the U.S. & Canadian markets.',
                },
                {
                    title: 'Lightning Fast',
                    image: 'arts/Speed.svg',
                    content: 'No research expertise required. Peekage\'s AI agents simplify study design and execution, enabling teams to launch tests quickly and receive insights in as little as 24 hours.',
                },
                {
                    title: 'High Quality Data',
                    image: 'arts/Fulfilment.svg',
                    content: 'Powered by our AI quality engine and multi-layered validation, Peekage delivers the highest-fidelity market data—so you can make decisions with absolute confidence.',
                },
                {
                    title: 'Targeting and Segmentation',
                    image: 'arts/Retarget.svg',
                    content: 'Leverage more than 200 consumer attributes and consumption habits to segment and recruit your ideal panel.',
                },
                {
                    title: 'Affordable',
                    image: 'arts/Affordable.svg',
                    content: 'With one subscription, all teams get big-market-research-firm quality at a fraction of the cost.',
                },
                {
                    title: 'One Platform for All Testing Needs',
                    image: 'arts/Opt-in-lg.svg',
                    content: 'Peekage offers a comprehensive suite of quantitative and qualitative product testing methods on a single, unified platform. Our AI streamlines study design, execution, and insight generation.',
                },
                {
                    title: 'End-to-End Fulfillment',
                    image: 'arts/online-experience-lg.svg',
                    content: 'Peekage manages product fulfillment from packaging and shipping to tracking and coordination—including products with special handling needs. This makes it easy to replace traditional CLT testing or run IHUT programs at scale.',
                },
            ],
        },
        relatedResources: {
            // Titles planned (URLs/images TBD): Demographic / Behavioral / Geographic Segmentation articles.
            title: 'Related Resources',
            items: [],
        },
        faqItems: [
            {
                title: 'What is customer segmentation analysis?',
                content:
                    'Customer segmentation analysis is the process of dividing your customer base into distinct groups based on shared characteristics, behaviors, or preferences. It lets you tailor your marketing, product, and sales strategies to each group instead of relying on one-size-fits-all messaging.',
            },
            {
                title: 'What data does Peekage use to build segments?',
                content:
                    'We draw on a first-party panel of 5M+ real shoppers profiled across 200+ attributes, from demographics and lifestyle to shopping habits and dietary needs. Where it adds value, we also fold in feedback from real product sampling and in-home testing, so your segments reflect how people actually behave, not just what they say.',
            },
            {
                title: 'How does Peekage turn the data into segments?',
                content:
                    'Our AI assistant does the heavy lifting. It works through the data to find patterns, group consumers into meaningful segments, and highlight the ones most valuable to your brand, then explains each in plain language with personas and recommendations. Our team reviews the output and adds context, so you get both speed and human judgment.',
            },
            {
                title: 'How do I know the segments are accurate?',
                content:
                    'Because they\'re built on real, engaged shoppers and grounded in actual behavior rather than borrowed third-party data, the segments closely represent your real market. Validating them against how people respond to your product makes them reliable predictors of how customers will act.',
            },
            {
                title: 'Is customer segmentation analysis worth it for a smaller or newer brand?',
                content:
                    'Yes. Established brands use it to uncover new growth, while emerging brands use it to identify their ideal buyer early and focus limited resources where they\'ll have the most impact.',
            },
            {
                title: 'Can customer segmentation analysis connect to other Peekage services?',
                content:
                    'Yes. Once you know your key segments from your customer segmentation analysis, you can target them directly with sampling campaigns or test new products through in-home testing, all on the same platform.',
            },
        ],
    },
];